import React from "react";
import { Title } from "@mantine/core";

export default function Header({ children, titleProps }) {
  return <Title {...titleProps}>{children}</Title>;
}

Header.defaultProps = {
  titleProps: {
    order: 4,
  },
  children: <React.Fragment>Header</React.Fragment>,
};
